




































import { Vue, Component } from "vue-property-decorator";
import gameState from "@/game.ts";

const bg = new Audio(require("@/assets/bg.ogg"));
const click = new Audio(require("@/assets/click.wav"));
bg.volume = 0.05;
bg.autoplay = true;
bg.loop = true;
click.volume = 0.5;

import game from "./Game.vue";

@Component({
  components: {
    game
  }
})
export default class extends Vue {
  game = false;

  mounted() {
    bg.play();
  }

  get win() {
    return gameState.win;
  }

  sound() {
    bg.paused ? bg.play() : bg.pause();
  }

  start() {
    click.play();
    this.game = true;
  }

  reload() {
    click.play();
    window.location.reload();
  }
}
